import { useMemo } from 'react'

// Feature flags configuration
const FEATURE_FLAGS = {
  contacts_transfer_restriction_enabled: true, // Allow transfer to non-users by default
  // Add more feature flags as needed
} as const

type FeatureFlagKey = keyof typeof FEATURE_FLAGS

/**
 * Hook to check if a feature flag is enabled
 * @param flagKey - The feature flag key to check
 * @returns boolean indicating if the feature is enabled
 */
export const useFeatureFlag = (flagKey: FeatureFlagKey): boolean => {
  return useMemo(() => {
    // In a real app, this would fetch from a remote config service
    // For now, return the default value
    return FEATURE_FLAGS[flagKey] ?? false
  }, [flagKey])
}

export default useFeatureFlag
